import React, { useState } from "react";
import "./AddAdmin.css";

const AddAdmin = () => {
  const [admin, setAdmin] = useState({
    full_name: "",
    phone_number: "",
    email: "",
    username: "",
    password: "",
    department: "Management",
    designation: "Founder",
    city: "",
    state: "",
    status: "active",
    date_joined: new Date().toISOString().slice(0, 10),
  });

  const [message, setMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAdmin({ ...admin, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await fetch(
        "https://www.actrofiteinfotech.com/rootservices/dashboard/add_admin.php",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(admin),
        }
      );

      const data = await res.json();
      if (data.success) {
        setMessage("Admin added successfully!");
        // Reset form
        setAdmin((prev) => ({
          ...prev,
          full_name: "",
          phone_number: "",
          email: "",
          username: "",
          password: "",
          city: "",
          state: "",
          department: "Management",
          designation: "Founder",
        }));
      } else {
        setMessage("Error: " + data.message);
      }
    } catch (err) {
      setMessage("Server error: " + err.message);
    }
  };

  return (
    <div className="add-admin-container">
      <h2>Add New Admin / Founder</h2>
      <form className="admin-form" onSubmit={handleSubmit}>
        <div className="form-row">
          <div className="form-group">
            <label>Full Name</label>
            <input
              type="text"
              name="full_name"
              value={admin.full_name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Phone Number</label>
            <input
              type="text"
              name="phone_number"
              value={admin.phone_number}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={admin.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Username</label>
            <input
              type="text"
              name="username"
              value={admin.username}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              name="password"
              value={admin.password}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>City</label>
            <input
              type="text"
              name="city"
              value={admin.city}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>State</label>
            <input
              type="text"
              name="state"
              value={admin.state}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Department</label>
            <input
              type="text"
              name="department"
              value={admin.department}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label>Designation</label>
            <input
              type="text"
              name="designation"
              value={admin.designation}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Status</label>
            <input type="text" value={admin.status} disabled />
          </div>
        </div>

        <button type="submit" className="submit-btn">
          Add Admin
        </button>
      </form>

      {message && <div className="add-admin-message">{message}</div>}
    </div>
  );
};

export default AddAdmin;
